export default class InitBeforeAjax {
    static customInitBeforeAjaxFunctions = [];

    static defaultInitBeforeAjax() {
        document.querySelectorAll('.keep-height-on-ajax').forEach( function (element, key) {
            element.style.minHeight = element.style.outerHeight;
        });
    }

    static addInitBeforeAjaxFunction(callback) {
        this.customInitBeforeAjaxFunctions.push(callback);
    }
}
